import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merge Tailwind classes, letting later ones win.
 *
 * Without `twMerge`, `cn("px-4", "px-6")` emits both and the winner depends on
 * stylesheet order — which is how a component's `className` prop silently stops
 * overriding anything.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
